import React from 'react';
import {ArrowDownIcon} from '@heroicons/react/24/outline';

interface IARUIPlace {}

const ARUIPlace = ({}: IARUIPlace) => {
  return (
    <div className="absolute top-38 left-[50%] w-80 transform -translate-x-[50%] flex flex-col items-center gap-4 rounded-2xl p-4 overflow-hidden pointer-events-none">
      <div className="absolute inset-0 bg-black opacity-50"></div>
      <div className="relative transform translate-y-4 mb-3">
        <ArrowDownIcon className="size-10 text-white animate-bounce" />
      </div>
      <p className="relative text-center text-white text-lg">Tap green circle to place model</p>
    </div>
  );
};

export default React.memo(ARUIPlace);
